import {useEffect, useRef} from 'react'
import {ArrUtil, ObjUtil} from 'yougile-util'
import {useBoard, useForceUpdate} from '@containers/hooks'
import {TableRow} from '../../common/base/table/types'
import {CrmActivitiesFilters, CrmActivitiesView, RowData} from '../common'
import {getFullBoardDealReport} from '../get-board-deal-report'
import {applyFilters} from './apply-filters'
import {createOnClickDeal} from './create-on-click-deal'
import {getStats} from './get-stats'
import {getUserIdsInProjectByBoard} from './get-user-ids-in-project-by-board'

interface Props {
  filters: CrmActivitiesFilters
  modified: number
}

export const useCrmActivities = ({
  filters,
  modified
}: Props): CrmActivitiesView => {
  const board = useBoard()
  const forceUpdate = useForceUpdate()
  const dealDataView = useRef<CrmActivitiesView>({})

  useEffect(() => {
    const rawData = getFullBoardDealReport(board, filters.assigned)

    const tableRows: TableRow<RowData>[] = ObjUtil.values(rawData)
      .flatMap(item =>
        item.activity.map(activity => ({
          id: activity.id,
          task: item.task,
          organization: item.organization,
          contactPerson: item.contactPerson,
          activity
        }))
      )
      .map(item => {
        return {
          onClick: createOnClickDeal(item.task, item.activity),
          data: item
        }
      })

    const stats = getStats(tableRows, filters)

    const projectUsersIds = getUserIdsInProjectByBoard(board)

    const appliedTableRows = applyFilters(tableRows, filters)
    const sortedTableRows = appliedTableRows.sort((a, b) => {
      return a.data.activity.deadline - b.data.activity.deadline
    })

    dealDataView.current = {
      tableRows: sortedTableRows,
      stats,
      depIds: ArrUtil.unique(
        ArrUtil.filterNil(
          tableRows.flatMap(row => [
            row.data.task?.id,
            row.data.organization?.id,
            row.data.contactPerson?.id
          ])
        )
      ),
      projectUsersIds
    }

    forceUpdate()
  }, [board, filters, modified])

  return dealDataView.current
}
